import { css, fontWeight, space } from 'bumbag';
import { _ as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';

var _templateObject;
var Heading = {
  styles: {
    base: function base(props) {
      return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      font-weight: ", ";\n\n      &&&:not(:last-child) {\n        margin-bottom: ", "rem;\n      }\n    "])), fontWeight('semibold')(props), space(5, 'minor')(props));
    }
  },
  h6: {
    fontSize: '250'
  }
};

export default Heading;
